var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5,0A7.48,7.48,0,0,0,.57,4.63a7.5,7.5,0,0,0,9.8,9.8A7.48,7.48,0,0,0,15,7.5,7.51,7.51,0,0,0,7.5,0ZM5,4.14A.3.3,0,0,1,5,4,.2.2,0,0,1,5.06,4a.2.2,0,0,1,.11,0,.19.19,0,0,1,.1,0l5.82,3.36.06,0a.25.25,0,0,1,0,.07s0,.06,0,.08a.19.19,0,0,1,0,.08.3.3,0,0,1-.08.08L5.27,11a.19.19,0,0,1-.1,0,.2.2,0,0,1-.11,0A.2.2,0,0,1,5,11a.3.3,0,0,1,0-.1Z"}));
}

Play.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Play;

Play.default = Play;
